import { Icon } from "@deligoo/ui"
import L from "leaflet"
import { memo } from "react"
import { renderToString } from "react-dom/server"
import { Marker } from "react-leaflet"
import { shallowEqual } from "react-redux"

import { useAppSelector } from "@/App"
import { selectClientById } from "@/store/clients"
import { Client, RootState } from "@/types"
import { ClientUtils, zIndexMapMarkers } from "@/utils"

import { ClientPopup } from "../Popup/ClientPopup"

type ClientsMarkersProps = {
  selector: (state: RootState) => Array<Client["id"]>
}

export const ClientsMarkers = ({ selector }: ClientsMarkersProps) => {
  const clientsIds = useAppSelector(selector, shallowEqual)

  return (
    <>
      {clientsIds.map((clientId) => (
        <ClientMarker clientId={clientId} key={clientId} />
      ))}
    </>
  )
}

const ClientMarker = memo(({ clientId }: { clientId: Client["id"] }) => {
  const client = useAppSelector(selectClientById(clientId), shallowEqual)

  if (!client) return null

  const icon = getClientMarkerIcon(client.location_type)
  const position: L.LatLngTuple = [client.lat, client.lng]

  if (position.some((coord) => !coord)) return null

  return (
    <Marker
      icon={icon}
      position={position}
      key={`clientId-marker-${clientId}`}
      zIndexOffset={zIndexMapMarkers.restaurants}
    >
      <ClientPopup clientId={clientId} />
    </Marker>
  )
})

export function getClientMarkerIcon(type: Client["location_type"] | "cluster") {
  return L.divIcon({
    className: "client-marker",
    html: renderToString(<Icon name={ClientUtils.getIconForLocationType(type)} className="marker-icon" />),
    iconAnchor: [10, 10],
    popupAnchor: [0, -16],
    iconSize: [20, 20],
  })
}
